import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {Button, Dialogue, Modal, addToast} from '@albert-io/atomic';
import {getModelForResourceType} from 'resources/modelRegistry';
import {invalidatePartialInterest} from 'resources/mandark.resource';
import {resource} from '@albert-io/json-api-framework/request/builder';
import notifier from '@albert-io/notifier';
import {invalidateFilters} from 'components/PracticeView/PracticeViewToolbar/Filters/filters.utils';

class DeleteFolderModal extends React.Component {
  static propTypes = {
    folder: PropTypes.instanceOf(getModelForResourceType('template_v1')),
    handleClose: PropTypes.func.isRequired,
    onSuccess: PropTypes.func
  };

  static defaultProps = {
    onSuccess: () => {}
  };

  /**
   * deletes the folder and invalidates the resource to force auto update
   */
  handleDeleteFolder = () => {
    const {folder} = this.props;

    folder
      .delete()
      .then(() => {
        this.props.onSuccess();
        addToast({
          message: 'Your folder was successfully deleted',
          title: 'Success!',
          type: 'success'
        });
        invalidatePartialInterest(
          resource('templates_v1').mandarkEndpoint(['templates_v1']).done()
        );

        invalidateFilters();
      })
      .catch((e) => {
        notifier.notify(e, {
          component: 'Folders',
          name: 'Folders: failed to delete folder'
        });
        addToast({
          message:
            'An error was encountered while trying to delete your folder. Please try again. If the problem persists, contact us.',
          title: 'Something went wrong',
          type: 'danger'
        });
      });
    this.props.handleClose();
  };

  render() {
    return (
      <Modal ariaLabel='Delete Folder Modal' handleClose={this.props.handleClose}>
        {({CloseButtonWrapper, modalContentStyle}) => {
          return (
            <Dialogue
              inModal
              size='m'
              hideCloseBtn
              title='Delete folder'
              handleClose={this.props.handleClose}
              className={classnames(modalContentStyle)}
            >
              <Dialogue.Body>Are you sure you want to delete your folder?</Dialogue.Body>
              <Dialogue.BtnGroup>
                <CloseButtonWrapper flex>
                  <Button variant='text'>Cancel</Button>
                </CloseButtonWrapper>
                <Button onClick={this.handleDeleteFolder}>Delete</Button>
              </Dialogue.BtnGroup>
            </Dialogue>
          );
        }}
      </Modal>
    );
  }
}

export default DeleteFolderModal;
